"use client"

import Navbar from "../../../components/navbar"
import Footer from "../../../components/footer"
import styles from "../css/driver.module.css"

/**
 * Shared shell for the driver screens so each view stops repeating the
 * navbar/footer/container scaffolding.
 *
 * `variant="map"` switches to the full-bleed navigation layout: no footer, no
 * page scroll, children own the whole area below the navbar.
 */
export default function DriverScreen({ children, variant = "default" }) {
  if (variant === "map") {
    return (
      <>
        <Navbar />
        <div className={styles.mapShell}>{children}</div>
      </>
    )
  }

  return (
    <div className={styles.pageWrapper}>
      <Navbar />
      <div className={styles.mainContent}>
        <div className={styles.contentContainer}>{children}</div>
      </div>
      <Footer />
    </div>
  )
}
